import { CognitoUser } from '@aws-amplify/auth';

export const getCognitoUserAttribute = (user: CognitoUser, name: string) => {
  return (user as any).attributes[name];
};

export const getCognitoUserAttributes = ({
  account,
  attrs,
}: {
  account?: CognitoUser;
  attrs: string[];
}) => (account ? attrs.map((a) => getCognitoUserAttribute(account, a)) : []);
